import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-10',
  templateUrl: './cards-10.component.html'
})
export class Cards10Component {



    }
